import LiteConfiguratorPage from "../UI/LiteConfiguratorPage";
import WorkspaceLiteProjects from "../UI/Workspace/Lite/WorkspaceLiteProjects";
import LeftLowerBarLiteSendPhoto from "../UI/LowerBar/LowerBarLeftSide/Lite/LeftLowerBarLiteSendPhoto";
import RightLowerBarLiteOpenProject from "../UI/LowerBar/LowerBarRightSide/Lite/RightLowerBarLiteOpenProject";
import LiteSidebarDesignList from "../UI/Sidebar/Lite/LiteSidebarDesignList";
import LeftLowerBarLiteDesign from "../UI/LowerBar/LowerBarLeftSide/Lite/LeftLowerBarLiteDesign";
import RightLowerBarNavButtons from "../UI/LowerBar/LowerBarRightSide/RightLowerBarNavButtons";
import ResultSidebarMenu from "../UI/Sidebar/SidebarComponents/ResultSidebarMenu";
import RightLowerBarOpenResultDesign from "../UI/LowerBar/LowerBarRightSide/RightLowerBarOpenResultDesign";
import WorkspaceResultMaterials from "../UI/Workspace/WorkspaceResultMaterials";
import RightLowerBarBack from "../UI/LowerBar/LowerBarRightSide/RightLowerBarBack";
import WorkspaceFabric from "../UI/Workspace/WorkspaceFabric";
import RightLowerBarBackOnly from "../UI/LowerBar/LowerBarRightSide/RightLowerBarBackOnly";
import WorkspaceResultSelectDesign from "../UI/Workspace/WorkspaceResultSelectDesign";
import LeftLowerBarLiteMaterials from "../UI/LowerBar/LowerBarLeftSide/Lite/LeftLowerBarLiteMaterials";
import LiteWorkspaceFabricVisualize from "../UI/Workspace/Lite/LiteWorkspaceFabricVisualize";
// import LiteDesignMaterialSidebarMenu from "../UI/Sidebar/Lite/LiteDesignMaterialSidebarMenu";
import SelectPlaneSidebarMenu from "../UI/Sidebar/SidebarComponents/SelectPlaneSidebarMenu";
import DesignMaterialSidebarMenu from "../UI/Sidebar/SidebarComponents/DesignMaterialSidebarMenu";
import RightLowerPrintResult from "../UI/LowerBar/LowerBarRightSide/RightLowerPrintResult";
import WorkspaceResultLite from "../UI/Workspace/Lite/WorkspaceResultLite";
import lowerBarLiteResult from "../UI/LowerBar/lowerBarLiteResult";
import LiteRightLowerBarBack from "../UI/LowerBar/LiteRightLowerBarBack";

export default {
    name: "configuratorLite",
    path: '/configurator_lite',
    component: LiteConfiguratorPage,
    meta: {requiresAuth: false, applicationVersion: 'lite'},
    children: [
        {
            name: "liteProjects",
            path: 'projects',
            components: {
                sidebar: null,
                workspace: WorkspaceLiteProjects,
                lowerBarLeft: null,
                lowerBarRight: null
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "liteSelectProjects",
            path: 'projects/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: null,
                workspace: WorkspaceLiteProjects,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarLiteOpenProject
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "liteDesignList",
            path: 'design/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: LiteSidebarDesignList,
                workspace: WorkspaceFabric,
                lowerBarLeft: LeftLowerBarLiteDesign,
                lowerBarRight: LiteRightLowerBarBack,
                lowerBarLight: lowerBarLiteResult,
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "liteDesignListSelected",
            path: 'design/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: LiteSidebarDesignList,
                workspace: LiteWorkspaceFabricVisualize,
                lowerBarLeft: LeftLowerBarLiteMaterials,
                lowerBarRight: null,
                lowerBarLight: lowerBarLiteResult,
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "lightDesignMaterialsEmpty",
            path: 'design/materials/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: SelectPlaneSidebarMenu,
                workspace: LiteWorkspaceFabricVisualize,
                lowerBarLeft: LeftLowerBarLiteDesign,
                lowerBarRight: LiteRightLowerBarBack,
                lowerBarLight: lowerBarLiteResult,
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "lightDesignMaterials",
            path: 'design/materials/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: DesignMaterialSidebarMenu,
                workspace: LiteWorkspaceFabricVisualize,
                lowerBarLeft: LeftLowerBarLiteDesign,
                lowerBarRight: LiteRightLowerBarBack,
                lowerBarLight: lowerBarLiteResult,
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "lightDesignMaterialsSelected",
            path: 'design/materials/project=:projectUUID/photo=:photoID/design=:designID/group=:groupID/element=:facadeElement',
            components: {
                sidebar: DesignMaterialSidebarMenu,
                workspace: LiteWorkspaceFabricVisualize,
                lowerBarLeft: LeftLowerBarLiteDesign,
                lowerBarRight: LiteRightLowerBarBack,
                lowerBarLight: lowerBarLiteResult,
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "lightResultImages",
            path: 'result/designs/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: null,
                workspace: WorkspaceResultLite,
                lowerBarLeft: LeftLowerBarLiteDesign,
                lowerBarRight: null
            },
            meta: {applicationVersion: 'lite'},
        },
        {
            name: "lightResultMaterials",
            path: 'result/materials/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: null,
                workspace: WorkspaceResultMaterials,
                lowerBarLeft: LeftLowerBarLiteDesign,
                lowerBarRight: null
            },
            meta: {applicationVersion: 'lite'},
        },
    ]
};
